import { Fragment } from "react";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import { NavLink } from "react-router-dom";
// import { withStyles } from "@mui/styles";

import { List, ListItem, Typography } from "@mui/material";

const styles = (theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing(3),
    overflowX: "auto",
  },
});

function OwnerResultDetails(props) {
  let searchResultDetails = props.searchResultDetails;
  let lookedFor = props.lookedFor;
  const resultList = searchResultDetails.map((searchResultDetails, i) => (
    <ListItem key={i}>
      {searchResultDetails ? (
        <Fragment>
          <NavLink
            to={"/domain/" + searchResultDetails.user_id}
            className="Nav_link"
          >
            {searchResultDetails.email}
          </NavLink>
        </Fragment>
      ) : null}
      <Typography>
        {searchResultDetails.user_id === lookedFor ? "***" : null}
      </Typography>
    </ListItem>
  ));

  return (
    <Container maxWidth="lg">
      <Grid container spacing={3}>
        <Grid item xs={12} md={8} lg={5}>
          {searchResultDetails ? <List>{resultList}</List> : null}
        </Grid>
      </Grid>
    </Container>
  );
}

// export default withStyles(styles, { withTheme: true })(OwnerResultDetails);
export default OwnerResultDetails